export { IssueButton } from './menu/menu-button';
export { removeExcludedArticles } from './responsive/remove-excluded-articles';
export {
	ReaderStateContext,
	type ReaderStateContextProps,
} from './model/reader-state-context';
export { SingleViewContext } from './replica/single/single-view.context';
export { useIssueOpenEvent } from './model/use-reading-events';

/**
 * `responsive/Responsive` and `replica/Replica` are two large, mutually
 * exclusive alternate renderers -- `pages/issue/Issue.tsx` route-splits them
 * (`lazy(loadResponsive)` / `lazy(loadReplica)`), and a plain static
 * re-export here would pull both into this barrel's own chunk, defeating
 * that split. Exporting the `import()` thunk itself, instead of the module,
 * keeps the dynamic import's specifier statically analyzable at its
 * original call site (so the bundler still gives each its own chunk) while
 * letting the consumer go through the public API rather than reaching past
 * it -- satisfies `fsd/no-public-api-sidestep` for real, not via an
 * exception.
 */
export const loadResponsive = () => import('./responsive/responsive');
export const loadReplica = () => import('./replica/replica');
